/**
 * Window Treatments 101 / blog listing: shared filter bar + load-more + article visibility.
 */
import { createSharedFilterBar } from './shared-filter-bar';

const initBlogFilters = () => {
  const loadMoreBtn = document.getElementById('loadMoreBtn');
  const hiddenArticles = document.querySelectorAll('.extra-article');
  const perLoad = 9;
  let currentIndex = 0;

  const articles = document.querySelectorAll('.article-card');
  const filterRoot = document.querySelector('[data-filter-bar="blog"]');
  if (!filterRoot && articles.length === 0) {
    return;
  }

  const articlesRootEl = document.getElementById('blog-articles-root');
  const articlesRootId = articlesRootEl
    ? articlesRootEl.getAttribute('data-articles-root-id')
    : '';
  const blogSearchUrl = articlesRootEl
    ? articlesRootEl.getAttribute('data-blog-search-url')
    : '/api/BlogArticleSearch/Search';

  const initialHidden = new WeakSet();
  articles.forEach((article) => {
    if (article.classList.contains('extra-article')) {
      initialHidden.add(article);
    }
  });

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      for (let i = currentIndex; i < currentIndex + perLoad; i += 1) {
        if (hiddenArticles[i]) {
          hiddenArticles[i].classList.remove('d-none');
        }
      }

      currentIndex += perLoad;

      if (currentIndex >= hiddenArticles.length) {
        loadMoreBtn.classList.add('d-none');
      }
    });

    if (hiddenArticles.length === 0) {
      loadMoreBtn.classList.add('d-none');
    }
  }

  const filterGroupKeys = ['room', 'solution', 'treatment', 'contenttype'];

  const appendQueryToUrl = (url, query) => {
    if (!url) {
      return url;
    }
    if (!query) {
      return url;
    }

    const hashIndex = url.indexOf('#');
    const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
    const base = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
    const separator = base.indexOf('?') >= 0 ? '&' : '?';
    return `${base}${separator}${query}${hash}`;
  };

  const updateArticleCardLinks = (query) => {
    articles.forEach((article) => {
      const links = article.querySelectorAll('a[href]');
      links.forEach((link) => {
        if (!link.dataset.baseHref) {
          link.dataset.baseHref = link.getAttribute('href');
        }
        link.setAttribute('href', appendQueryToUrl(link.dataset.baseHref, query));
      });
    });
  };

  const applyArticleVisibility = (filters, meta) => {
    const searchText = (meta && meta.search) || '';
    const searchActive = searchText.length > 0;
    const searchMatchIds = meta && meta.searchMatchIds;

    const filtersActive = filterGroupKeys.some(key => (filters[key] || []).length > 0)
      || searchActive;

    articles.forEach((article) => {
      let visible = true;

      filterGroupKeys.forEach((type) => {
        if ((filters[type] || []).length > 0) {
          const data = (article.dataset[type] || '')
            .toLowerCase()
            .split(',')
            .map(v => v.trim());

          if (!filters[type].some(f => data.indexOf(String(f).toLowerCase()) !== -1)) {
            visible = false;
          }
        }
      });

      if (searchActive && searchMatchIds) {
        if (!searchMatchIds.has(String(article.dataset.id || ''))) {
          visible = false;
        }
      }

      if (filtersActive) {
        article.classList.toggle('d-none', !visible);
      } else if (initialHidden.has(article)) {
        article.classList.add('d-none', 'extra-article');
      } else {
        article.classList.remove('d-none');
      }
    });

    const visibleArticles = Array.prototype.slice.call(articles)
      .filter(a => !a.classList.contains('d-none'));

    const noResultsMessage = document.getElementById('noResultsMessage');
    if (noResultsMessage) {
      noResultsMessage.classList.toggle('d-none', visibleArticles.length !== 0);
    }

    if (loadMoreBtn) {
      if (filtersActive) {
        loadMoreBtn.classList.add('d-none');
      } else {
        loadMoreBtn.classList.toggle('d-none', hiddenArticles.length === 0);
      }
    }

    updateArticleCardLinks((meta && meta.queryString) || '');
  };

  createSharedFilterBar({
    idPrefix: 'blog',
    groupKeys: filterGroupKeys,
    urlSync: true,
    search: {
      fetchMatchIds: (term) => {
        const url = `${blogSearchUrl}?rootId=${encodeURIComponent(articlesRootId)}&q=${encodeURIComponent(term)}`;
        return fetch(url, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Search request failed');
            }
            return response.json();
          })
          .then(data => ((data && data.ids) ? data.ids : []));
      },
    },
    onFiltersChange: applyArticleVisibility,
  });
};

export default initBlogFilters;
export { initBlogFilters };
